import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Btn } from "../components/ui/kit";

const QUICK = [
  { label: "Owner (Super Admin)", email: "micmiccarlos@gmail.com", password: "RestoCore2026" },
  { label: "Admin", email: "admin@restocore.ph", password: "admin123" },
  { label: "Waiter", email: "waiter@restocore.ph", password: "waiter123" },
  { label: "Kitchen", email: "kitchen@restocore.ph", password: "kitchen123" },
  { label: "Accounting", email: "accounting@restocore.ph", password: "accounting123" },
];

export default function Login() {
  const { login, apiError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
    } catch (e2) {
      setErr(apiError(e2));
    } finally {
      setBusy(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const quick = (q) => { setEmail(q.email); setPassword(q.password); };

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 lg:grid lg:grid-cols-2">
      {/* Brand panel */}
      <div className="relative hidden overflow-hidden border-r border-zinc-800 p-12 lg:flex lg:flex-col lg:justify-between">
        <div
          className="absolute inset-0 opacity-30"
          style={{ backgroundImage: "url(https://images.unsplash.com/photo-1537495988501-f9cd94a78f3e?q=80&w=1400)", backgroundSize: "cover", backgroundPosition: "center" }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/60 via-zinc-950/85 to-zinc-950" />
        <div className="relative">
          <div className="flex items-center gap-2 text-emerald-400">
            <span className="grid h-9 w-9 place-items-center rounded-lg bg-emerald-500 font-head text-lg font-black text-zinc-950">R</span>
            <span className="font-head text-sm font-bold tracking-[0.25em] text-zinc-300">MSC INTELLIGENCE</span>
          </div>
        </div>
        <div className="relative">
          <h1 className="font-head text-5xl font-black leading-tight">RestoCore<br />Engine</h1>
          <p className="mt-4 max-w-sm text-lg text-emerald-300">Every visit creates value.</p>
          <p className="mt-6 max-w-md text-sm text-zinc-400">
            One confirmed order = one source of operational truth. Ordering, kitchen, inventory, purchasing,
            payments and accounting through a single trusted core.
          </p>
        </div>
        <div className="relative text-xs text-zinc-500">
          Systems Owner-Architect · <span className="text-zinc-300">Michael Carlos</span>
          <span className="mx-2">|</span>
          Chief Technology Officer · <span className="text-zinc-300">Erick Kalugdan</span>
          <div className="mt-1 text-zinc-600">Sandbox v0.1</div>
        </div>
      </div>

      {/* Form panel */}
      <div className="flex min-h-screen items-center justify-center p-6">
        <div className="w-full max-w-md rc-rise">
          <div className="mb-8 lg:hidden">
            <span className="font-head text-2xl font-black text-emerald-400">RestoCore Engine</span>
            <p className="text-sm text-zinc-400">Every visit creates value.</p>
          </div>
          <h2 className="font-head text-2xl font-bold">Sign in</h2>
          <p className="mt-1 text-sm text-zinc-400">Access your role-based restaurant operating system.</p>

          <button
            data-testid="google-login-btn"
            onClick={google}
            className="mt-6 flex w-full items-center justify-center gap-3 rounded-full border border-zinc-700 bg-white px-4 py-3 font-semibold text-zinc-900 transition hover:bg-zinc-100"
          >
            <img alt="" className="h-5 w-5" src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" />
            Continue with Google
          </button>

          <div className="my-5 flex items-center gap-3 text-xs text-zinc-600">
            <div className="h-px flex-1 bg-zinc-800" /> OR EMAIL <div className="h-px flex-1 bg-zinc-800" />
          </div>

          <form onSubmit={submit} className="space-y-3">
            <input
              data-testid="login-email" type="email" required placeholder="Email" value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-xl border border-zinc-800 bg-zinc-900 px-4 py-3 outline-none focus:border-emerald-500"
            />
            <input
              data-testid="login-password" type="password" required placeholder="Password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xl border border-zinc-800 bg-zinc-900 px-4 py-3 outline-none focus:border-emerald-500"
            />
            {err && <p data-testid="login-error" className="text-sm text-rose-400">{err}</p>}
            <Btn data-testid="login-submit" variant="emerald" className="w-full py-3" disabled={busy}>
              {busy ? "Signing in…" : "Sign in"}
            </Btn>
          </form>

          <div className="mt-6 rounded-xl border border-zinc-800 bg-zinc-900/50 p-3">
            <div className="text-xs font-semibold uppercase tracking-wider text-zinc-500">Sandbox quick logins</div>
            <div className="mt-2 flex flex-wrap gap-2">
              {QUICK.map((q) => (
                <button
                  key={q.email}
                  data-testid={`quick-${q.label.split(" ")[0].toLowerCase()}`}
                  onClick={() => quick(q)}
                  className="rounded-full border border-zinc-700 px-3 py-1 text-xs text-zinc-300 hover:border-emerald-500 hover:text-emerald-300"
                >
                  {q.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
